<script setup>
  import { ref } from 'vue'
  import { useI18n } from 'vue-i18n';
  import axios from '../services/ApiService';

  const { t } = useI18n();

  const props = defineProps({
    itemId: {
      type: Number,
      required: true
    },
    wishLists: {
      type: Array,
      required: true,
      default: []
    },
    selectedWishLists: {
      type: Array,
      required: true,
      default: []
    }
  });

  const localWishLists = ref(props.wishLists);
  const localeSelectedWishLists = ref(props.selectedWishLists);

  const updateList = async () => {
    try {
      const response = await axios.get(`/wish_lists.json?item_ids=${props.itemId}`);
      localWishLists.value = response.data.wish_lists;
      localeSelectedWishLists.value = response.data.item_ids[props.itemId];
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const toggle = async (wishListId) => {
    try {
      const response = await axios.post(`/wish_lists/${wishListId}/toggle.json?item_ids=${props.itemId}`);
      localWishLists.value = response.data.wish_lists;
      localeSelectedWishLists.value = response.data.item_ids[props.itemId];
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
</script>

<template>
  <div class="dropdown" data-bs-toggle="tooltip" :data-bs-title="t('wish_lists.tooltip')">
    <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false" @click="updateList()">
      <i class="bi bi-bookmark-fill text-danger" v-if="localeSelectedWishLists.length > 0"></i>
      <i class="bi bi-bookmark" v-else></i>
    </button>
    <ul class="dropdown-menu">
      <li v-for="wishList in localWishLists" :key="wishList.id">
        <a class="dropdown-item" href="#" @click.prevent="toggle(wishList.id)">
          <i class="bi bi-check-square" v-if="localeSelectedWishLists.includes(wishList.id)"></i>
          <i class="bi bi-square" v-else></i>
          {{ wishList.name }}
          <i class="bi bi-people" v-if="wishList.privacy === 'library'"></i>
        </a>
      </li>
      <li v-if="localWishLists.length > 0"><hr class="dropdown-divider" /></li>
      <li><a class="dropdown-item" :key="0" href="#" @click.prevent="toggle(0)">{{ t('wish_lists.new_wish_list') }}</a></li>
    </ul>
  </div>
</template>

<style>

</style>

<i18n src="../locales/en.json" global></i18n>
<i18n src="../locales/fr.json" global></i18n>
<i18n src="../locales/es.json" global></i18n>
<i18n src="../locales/it.json" global></i18n>
<i18n src="../locales/pt.json" global></i18n>
<i18n src="../locales/de.json" global></i18n>
